(function () {
  angular.module('app.widgets.common.go-url').constant('ADOBE_URL', 'https://www.adobe.com');
})();
